import AssessmentsOverviewHeader from './Components/AssessmentsOverviewHeader';
import AssessmentsOverviewTabs from './Components/AssessmentsOverviewTabs';
import Page from '@/Components/page';

const AssessmentsOverviewPageContent = () => {
    return (
        <Page className="bg-alicia">
            <div data-cy="pageContentContainer" className="flex h-full flex-1 flex-col overflow-auto">
                <AssessmentsOverviewHeader />
                <div className="container mx-auto h-full max-w-6xl py-8">
                    <AssessmentsOverviewTabs />
                </div>
            </div>
        </Page>
    );
};

export default AssessmentsOverviewPageContent;
